import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@/assets/icons/LibrarySvg';
const RoundCounterToggleButton = ({ onClick, show, pageButtonsContainer, }) => {
    if (!show || !pageButtonsContainer)
        return null;
    return (_jsx("button", { className: "show-timer-form", style: { order: 20 }, title: "Round counter", onClick: onClick, onMouseDown: (e) => e.stopPropagation(), type: "button", children: _jsx(Icon, { name: "timer_3" }) }));
};
export default RoundCounterToggleButton;
